import React, { useState } from "react";
import { IoTime } from "react-icons/io5";
import { formatDateTime } from "../../Helpers/Utils";
import { Link } from "react-router-dom";

const Timeline = ({ userLog, className }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleDetails = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className={`card border-0 shadow-sm rounded-4 timeline-card ${className}`}>
      <div className="p-3">
        <h5 className="fw-semibold d-flex align-items-center gap-2">
          <IoTime /> Activity Timeline
        </h5>
        <hr className="m-0" />
      </div>

      <div className={`card-body timeline-body `}>
        {userLog?.length > 0 ? (
          userLog.map((log, i) => (
            <div key={i} className="timeline-item">
              <div className={`timeline-dot ${log?.priority ? "priority" : ""}`}>
                {log?.action?.charAt(0)}
              </div>
              <div className="timeline-content">

                <div className="d-flex justify-content-between flex-wrap">
                  <div>
                    <div className="fw-semibold action-title">
                      {log?.action}
                      <span className="badge bg-light text-dark ms-2">
                        {log?.userType}
                      </span>
                    </div>

                    <div className="text-muted small">
                      {log?.msg}
                    </div>
                  </div>

                  <div className="text-muted small text-end">
                    { formatDateTime(log?.createdAt) }
                  </div>
                </div>

                <div className="meta-info mt-2">
                  <span>{log?.previousData?.msg} {"("} { log?.userType === "Admin" ? log?.userId : log?.userType === "Staff" ? <Link className="btn-link" to={`/staff/details/${log?.userId}`} >{log?.userId}</Link> : "SELF" } {")"}</span>
                </div>
                

                {log?.previousData?.data && (
                  <button className="btn btn-sm btn-link mt-2 p-0" onClick={() => toggleDetails(i)} >
                    {openIndex === i ? "Hide Changes ▲" : "View Changes ▼"}
                  </button>
                )}

                {openIndex === i && (
                  <div className="change-box mt-2">
                    <pre>
                      {JSON.stringify(log?.previousData?.data, null, 2)}
                    </pre>
                  </div>
                )}

              </div>
            </div>
          ))
        ) : (
          <p className="text-muted">No activity found</p>
        )}
      </div>
    </div>
  );
};

export default Timeline;